import { Observable } from 'rxjs';

import { AppService } from 'app/services/app.service';
import {
  ConviteVirtualResponse,
  ConviteVirtualUpdateRequest
} from 'app/pages/full-pages/convite-virtual/convite-virtual.models';

export abstract class AbConviteVirtual extends AppService {
  abstract buscar(): Observable<ConviteVirtualResponse>;
  abstract atualizar(
    request: ConviteVirtualUpdateRequest
  ): Observable<ConviteVirtualResponse>;
}
